import axios from "axios";
import { Message, MessageBox } from "element-ui";
import { debounce } from "throttle-debounce";
import i18n from "../lang";
import Vue from "vue";
import router from "../router";

const http = axios.create({
  baseURL: process.env.BASE_URL,
  timeout: 30000
});

/* 会话失效弹窗提示 */
const timeoutMessageBox = debounce(500, () => {
  MessageBox.alert(
    i18n.t(
      "local.your_login_has_timed_out_please_click_the_button_to_log_in_again"
    ),
    i18n.t("local.note"),
    {
      center: true,
      callback: () => {
        // token过期移除token
        Vue.prototype.$cookies.remove("token");
        router.replace("/");
      }
    }
  );
});

// 请求拦截
http.interceptors.request.use(config => {
  const token = Vue.prototype.$cookies.get("token");
  if (token) {
    config.headers["token"] = token;
  }
  if (config.method === "post") {
    config.headers["Content-Type"] = "application/json";
  }
  const mode = process.env.NODE_ENV;
  if (mode == "development") {
    config.headers["hostname"] = "test.ywlearnin.com"; //本地开发写死
  } else {
    config.headers["hostname"] = location.hostname;
  }
  return config;
});

// 响应拦截
http.interceptors.response.use(
  response => {
    let res = response.data;
    if (res.data && res.data === "error") {
      if (["W0001", "W0003", "W0005"].includes(res.result.code)) {
        timeoutMessageBox();
      } else {
        if (i18n.te(`local.${res.result.code}`)) {
          Message.error(i18n.t(`local.${res.result.code}`));
        } else {
          Message.error(i18n.t("local.error_request"));
        }
      }
      return Promise.reject(res);
    }
    return Promise.resolve(res);
  },
  error => {
    Message.error(error.message);
    return Promise.reject(error);
  }
);

export default http;



// WEBPACK FOOTER //
// ./src/util/axios.js